import { useState } from "react";
import { http, errText, inr } from "../lib/api";
import { DatePicker } from "../components/DatePicker";

export default function MyPlan() {
  const [code, setCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [booking, setBooking] = useState({ preferred_day: "", window: "Morning" });
  const [msg, setMsg] = useState("");

  const norm = () => "+91" + mobile.replace(/\D/g, "").slice(-10);
  const field = "w-full min-h-[44px] rounded-2xl border-2 border-[#e1e2e5] px-4 py-2.5 font-medium focus:border-[#004040] outline-none";

  const load = async () => {
    setBusy(true); setErr(""); setMsg(""); setData(null);
    try {
      const { data: d } = await http.post("/my-plan", { order_code: code.trim(), mobile: norm() });
      setData(d);
    } catch (e) { setErr(e?.response?.data?.detail === "not_found" ? "No plan found for that order code and mobile." : errText(e?.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const resubmit = async () => {
    try { const { data: r } = await http.post("/my-plan/resubmit", { order_code: code.trim(), mobile: norm() });
      setMsg(`New free loan enquiry created: ${r.lead_id}`); } catch (e) { setErr(errText(e?.response?.data?.detail)); }
  };
  const book = async () => {
    try { await http.post("/bookings", { order_code: code.trim(), mobile: norm(), preferred_day: booking.preferred_day, window: booking.window });
      setMsg("Booking requested. Our consultant will confirm."); } catch (e) { setErr(errText(e?.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen bg-[#f4f5f6]">
      <header className="bg-white border-b border-[#e1e2e5]">
        <div className="max-w-[900px] mx-auto px-4 h-[72px] flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><img src="/assets/logo.png" alt="Bhartiya Loan Capital" className="h-9" /></a>
          <a href="/" className="font-bold text-sm underline">← Home</a>
        </div>
      </header>
      <main className="max-w-[900px] mx-auto px-4 py-10">
        <h1 className="text-3xl font-extrabold tracking-[-0.035em]">My plan</h1>
        <p className="mt-2 text-[#6b6f76]">Enter your order code and the mobile you used.</p>
        <div className="mt-5 grid sm:grid-cols-[1fr_1fr_auto] gap-3 bg-white p-4 rounded-[24px] border border-[#e1e2e5]">
          <input className={field} placeholder="Order code, e.g. BLC-ORD-2026-000001" value={code} onChange={(e) => setCode(e.target.value)} data-testid="myplan-code" />
          <div className="flex items-center rounded-2xl border-2 border-[#e1e2e5] overflow-hidden focus-within:border-[#004040]">
            <span className="px-3 text-[#6b6f76] font-bold">+91</span>
            <input className="flex-1 min-h-[44px] px-2 outline-none" inputMode="numeric" maxLength={10} placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))} data-testid="myplan-mobile" />
          </div>
          <button className="min-h-[44px] px-6 rounded-full bg-[#191c1f] text-white font-bold" onClick={load} disabled={busy || !code || mobile.length < 10} data-testid="myplan-submit">{busy ? "…" : "View"}</button>
        </div>
        {err && <p className="mt-3 text-[#8a2412] font-bold" data-testid="myplan-error">{err}</p>}
        {msg && <p className="mt-3 text-[#004040] font-bold" data-testid="myplan-msg">{msg}</p>}

        {data && (
          <div className="mt-6 grid md:grid-cols-2 gap-5" data-testid="myplan-detail">
            <div className="bg-white rounded-[24px] border border-[#e1e2e5] p-6">
              <div className="text-sm text-[#6b6f76] font-bold">{data.order.plan_label} plan · {data.paid ? "Paid" : "Pending"}</div>
              <div className="mt-2 grid grid-cols-3 gap-3">
                {[["Bought", data.minutes_total], ["Used", data.minutes_used], ["Left", data.minutes_left]].map(([k, v]) => (
                  <div key={k} className="rounded-2xl bg-[#f4f5f6] p-3"><div className="text-xs font-bold text-[#6b6f76]">{k}</div><div className="text-2xl font-extrabold">{v}</div></div>
                ))}
              </div>
              <p className="mt-3 text-sm text-[#6b6f76]">Expires: {data.order.expiry_display} {data.expired && <span className="text-[#8a2412] font-bold">(expired)</span>}</p>
              <p className="text-sm text-[#6b6f76]">Amount paid: Rs {inr(data.order.amount)}</p>
              <button className="mt-4 min-h-[44px] px-5 rounded-full bg-[#f06400] text-[#191c1f] font-extrabold" onClick={resubmit} data-testid="myplan-resubmit">Resubmit to loan facilitation</button>
            </div>
            <div className="bg-white rounded-[24px] border border-[#e1e2e5] p-6">
              <h3 className="font-extrabold">Book a session</h3>
              <label className="block text-sm font-bold mt-3 mb-1">Preferred day</label>
              <DatePicker value={booking.preferred_day} onChange={(v) => setBooking((b) => ({ ...b, preferred_day: v }))} testId="myplan-booking-day" />
              <label className="block text-sm font-bold mt-3 mb-1">Window</label>
              <div className="inline-flex rounded-full bg-[#f4f5f6] p-1">
                {["Morning", "Afternoon", "Evening"].map((w) => (
                  <button key={w} onClick={() => setBooking((b) => ({ ...b, window: w }))} className={`px-4 py-2 rounded-full text-sm font-bold ${booking.window === w ? "bg-[#191c1f] text-white" : ""}`}>{w}</button>
                ))}
              </div>
              <button className="block mt-4 min-h-[44px] px-5 rounded-full bg-[#191c1f] text-white font-bold" onClick={book} disabled={!booking.preferred_day} data-testid="myplan-book">Request this time</button>
              <h3 className="font-extrabold mt-6">Session history</h3>
              <ul className="mt-2 space-y-2 text-sm">
                {data.sessions.length === 0 && <li className="text-[#6b6f76]">No sessions logged yet.</li>}
                {data.sessions.map((s, i) => (
                  <li key={i} className="rounded-xl bg-[#f4f5f6] p-3"><strong>{s.minutes} min</strong> · {s.ts?.slice(0, 10)} {s.notes && <>· {s.notes}</>} {s.outcome && <span className="text-[#004040] font-bold">· {s.outcome}</span>}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
